import React from 'react';

export default function Toast({ message, type }) {
  return (
    <div className={`toast ${type}`}>
      <span className="toast-icon">
        {type === 'success' ? (
          <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}><path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7"/></svg>
        ) : (
          <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12"/></svg>
        )}
      </span>
      {message}
    </div>
  );
}
